import moment from 'moment';
import GeneralEnumService from '../../enumerables/general-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';

export const groupProgramAnswerForPlot = (
    data: any,
    programBookAnswers: any,
    globalFilters: any,
    isHideButton?: any,
) => {
    const { programMainCategories, ...res } = data;
    const answers = programBookAnswers.data.list;

    const answersByTargetId: Record<number, any[]> = {};
    for (const ans of answers) {
        const tid = ans.programTarget?.id;
        if (!tid) continue;
        if (!answersByTargetId[tid]) {
            answersByTargetId[tid] = [];
        }
        answersByTargetId[tid].push(ans);
    }

    const EnumSet = GeneralEnumService ? GeneralEnumService.getEnum('ProgramPrompt') : {};
    const programPromptItems: SelectObject[] = getValFromEnum(EnumSet);

    //console.log('globalFilters', globalFilters);

    let answersData: any[] = [];

    let dataSet: any[] = [];

    if (programMainCategories) {
        let sectionInfo = {};
        const dataSectionSet: any[] = [];
        Object.values(programMainCategories).map((section: any, i: number) => {
            sectionInfo = {
                id: section.id,
                title: section.title,
                isHidden: section.isHidden,
                description: section.description,
            };
            let domainInfo = {};
            const dataDomainSet: any[] = [];

            section.programCategories = section.programCategories
                ? !Array.isArray(section.programCategories)
                    ? Object.values(section.programCategories)
                    : section.programCategories
                : [];
            section.programCategories.forEach((domain: any, j: number) => {
                domainInfo = {
                    id: domain.id,
                    title: domain.title,
                    isHidden: domain.isHidden,
                    description: domain.description,
                };
                let longTermInfo = {};
                const dataLongTermSet: any[] = [];

                domain.programCategories = domain.programCategories
                    ? !Array.isArray(domain.programCategories)
                        ? Object.values(domain.programCategories)
                        : domain.programCategories
                    : [];
                domain.programCategories.forEach((longTerm: any, k: number) => {
                    longTermInfo = {
                        id: longTerm.id,
                        title: longTerm.title,
                        isHidden: longTerm.isHidden,
                        description: longTerm.description,
                    };
                    let shortTermInfo = {};
                    const dataShortTermSet: any[] = [];

                    longTerm.programCategories = longTerm.programCategories
                        ? !Array.isArray(longTerm.programCategories)
                            ? Object.values(longTerm.programCategories)
                            : longTerm.programCategories
                        : [];
                    longTerm.programCategories.forEach((shortTerm: any, l: number) => {
                        shortTermInfo = {
                            id: shortTerm.id,
                            title: shortTerm.title,
                            isHidden: shortTerm.isHidden,
                            description: shortTerm.description,
                        };
                        let targetInfo = {
                            id: '',
                            title: '',
                            prompt: '',
                            type: '',
                            description: '',
                            isHidden: '',
                            programTargetPhases: [],
                            isPhased: false,
                        };
                        shortTerm.programTargets = shortTerm.programTargets
                            ? !Array.isArray(shortTerm.programTargets)
                                ? Object.values(shortTerm.programTargets)
                                : shortTerm.programTargets
                            : [];
                        shortTerm.programTargets.forEach((target: any, m: number) => {
                            /*const EnumSet = GeneralEnumService ? GeneralEnumService.getEnum('ProgramPrompt') : {};
                            const programPromptItems: SelectObject[] = getValFromEnum(EnumSet);*/
                            const valPrompt = programPromptItems.find((it) => it.value === target.prompt);

                            targetInfo = {
                                id: target.id,
                                title: target.title,
                                prompt: valPrompt ? valPrompt.label : '',
                                type: target.type,
                                description: target.description,
                                isHidden: target.isHidden,
                                programTargetPhases: target.programTargetPhases,
                                isPhased: target.isPhased,
                            };
                            // let answersSet = answers.filter((its: any) => its.programTarget?.id === target.id);

                            let answersSet = answersByTargetId[target.id] ? [...answersByTargetId[target.id]] : [];

                            /* if (target.isPhased == true) {
                                const vals: any[] = [];
                                target.programTargetPhases.forEach((p: any, pp: number) => {
                                    const val = {
                                        title: p.title,
                                        startDate: p.startDate,
                                        endDate: p.endDate,
                                        isMastered: p.isMastered,
                                    };
                                    if (val) {
                                        vals.push(val);
                                        targetInfo.programTargetPhases = vals;
                                    }
                                });
                            }*/

                            const prompts: any[] = [];
                            if (target.type == 1) {
                                const promptValue = programPromptItems.find((it: SelectObject) => {
                                    if (it.value == target.prompt) {
                                        return it;
                                    }
                                    return false;
                                });
                                if (promptValue) {
                                    prompts.push(promptValue.label);
                                }
                            } else if (target.type == 3) {
                                target.programTargetOptions.forEach((p: any, pp: number) => {
                                    const promptValue = programPromptItems.find((it: SelectObject) => {
                                        if (it.value == p.prompt) {
                                            return it;
                                        }
                                        return false;
                                    });
                                    if (promptValue) {
                                        prompts.push(promptValue.label);
                                        targetInfo.prompt = prompts.join(',');
                                    }
                                });
                            }
                            /*answersSet.forEach((answer: any, g: number) => {
                                let isExist = 0;
                                answersSet.forEach((ans: any, o: number) => {
                                    if (
                                        ans.seanceDate ==
                                            (answer.seance
                                                ? moment(answer.seance.startTime, 'YYYY-MM-DD HH:mm:ss').format('ll')
                                                : '[canceled]') &&
                                        ans.answer == answer.answer &&
                                        ans.isHidden == target.isHidden &&
                                        ans.isSkip == answer.isSkip &&
                                        ans.prompts == prompts.join(',')
                                    ) {
                                        isExist = 1;
                                        return;
                                    }
                                });

                                if (isExist == 0) {
                                    const activePhase = target?.programTargetPhases?.find(
                                        (its: any) =>
                                            (moment(answer.seance.startTime, 'YYYY-MM-DD').isSameOrAfter(
                                                moment(its.startDate, 'YYYY-MM-DD'),
                                            ) &&
                                                moment(answer.seance.startTime, 'YYYY-MM-DD').isSameOrBefore(
                                                    moment(its.endDate, 'YYYY-MM-DD'),
                                                )) ||
                                            (moment(answer.seance.startTime, 'YYYY-MM-DD').isSameOrAfter(
                                                moment(its.startDate, 'YYYY-MM-DD'),
                                            ) &&
                                                its.endDate == null),
                                    );

                                    answersSet[g] = {
                                        answer: answer.answer,
                                        isHidden: target.isHidden,
                                        phasePeriod: false,
                                        phasePeriodSortFlag: 1,
                                        phaseTitle: '',
                                        isSkip: answer.isSkip,
                                        prompts: prompts.join(','),
                                        activePhase: target.isPhased ? activePhase : null,
                                        seanceDate: answer.seance
                                            ? moment(answer.seance.startTime, 'YYYY-MM-DD HH:mm:ss').format('ll')
                                            : '[canceled]',
                                    };
                                } else {
                                }
                            });*/

                            const usedKeys = new Set<string>();

                            answersSet = answersSet
                                .map((answer: any) => {
                                    const seanceDate = answer.seance
                                        ? moment(answer.seance.startTime, 'YYYY-MM-DD HH:mm:ss').format('ll')
                                        : '[canceled]';

                                    const key = [
                                        seanceDate,
                                        answer.answer,
                                        target.isHidden,
                                        answer.isSkip,
                                        prompts.join(','),
                                    ].join('|');

                                    if (usedKeys.has(key)) {
                                        return null;
                                    }
                                    usedKeys.add(key);

                                    // const activePhase = target?.programTargetPhases?.find(/* ... */);
                                    const programTargetPhases = Array.isArray(target?.programTargetPhases)
                                        ? target.programTargetPhases
                                        : target?.programTargetPhases
                                        ? Object.values(target.programTargetPhases)
                                        : [];

                                    const activePhase = programTargetPhases.find(
                                        (its: any) =>
                                            (moment(answer.seance.startTime, 'YYYY-MM-DD').isSameOrAfter(
                                                moment(its.startDate, 'YYYY-MM-DD'),
                                            ) &&
                                                moment(answer.seance.startTime, 'YYYY-MM-DD').isSameOrBefore(
                                                    moment(its.endDate, 'YYYY-MM-DD'),
                                                )) ||
                                            (moment(answer.seance.startTime, 'YYYY-MM-DD').isSameOrAfter(
                                                moment(its.startDate, 'YYYY-MM-DD'),
                                            ) &&
                                                its.endDate == null),
                                    );

                                    return {
                                        answer: answer.answer,
                                        isHidden: target.isHidden,
                                        phasePeriod: false,
                                        phasePeriodSortFlag: 1,
                                        phaseTitle: '',
                                        isSkip: answer.isSkip,
                                        prompts: prompts.join(','),
                                        activePhase: target.isPhased ? activePhase : null,
                                        seanceDate,
                                    };
                                })
                                .filter(Boolean);

                            const phases: any[] = [];

                            if (target.isPhased && target.programTargetPhases.length && answersSet.length) {
                                target.programTargetPhases?.forEach((phase: any, m: number) => {
                                    if (
                                        phase.startDate
                                        //&& phase.startDate > globalFilters.dateFrom &&
                                        //phase.startDate < globalFilters.dateTo
                                    ) {
                                        answersSet.push({
                                            answer: 0,
                                            isHidden: false,
                                            isSkip: false,
                                            prompts: '',
                                            activePhase: null,
                                            phasePeriod: true,
                                            phasePeriodSortFlag: 0,
                                            phaseTitle: 'Phase ' + phase.title + ' starts.',
                                            seanceDate: moment(phase.startDate, 'YYYY-MM-DD HH:mm:ss').format('ll'),
                                        });
                                    }
                                    if (
                                        phase.endDate
                                        //&& phase.endDate > globalFilters.dateFrom &&
                                        // phase.endDate < globalFilters.dateTo
                                    ) {
                                        answersSet.push({
                                            answer: 0,
                                            isHidden: false,
                                            isSkip: false,
                                            prompts: '',
                                            activePhase: null,
                                            phasePeriod: true,
                                            phasePeriodSortFlag: 2,
                                            phaseTitle: 'Phase ' + phase.title + ' ends.',
                                            seanceDate: moment(phase.endDate, 'YYYY-MM-DD HH:mm:ss').format('ll'),
                                        });
                                    }
                                    const startDate =
                                        phase.startDate &&
                                        phase.startDate > globalFilters.dateFrom &&
                                        phase.startDate < globalFilters.dateTo
                                            ? moment(phase.startDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
                                            : null;
                                    const endDate =
                                        phase.endDate &&
                                        phase.endDate > globalFilters.dateFrom &&
                                        phase.endDate < globalFilters.dateTo
                                            ? moment(phase.endDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
                                            : null;
                                    const phaseTitle = phase.title ? phase.title : 'No Phase';
                                    let uniqueTitle = phaseTitle + ': ' + startDate;

                                    if (endDate) {
                                        uniqueTitle = uniqueTitle + ' - ' + endDate;
                                    }

                                    phases.push({
                                        id: m,
                                        name: uniqueTitle,
                                        start: startDate,
                                        end: endDate,
                                    });
                                });
                            }

                            answersSet = answersSet.filter((el: any) => el.id === undefined && el.isSkip != true);

                            answersSet.sort(function (a: any, b: any) {
                                const c: any = new Date(a.seanceDate);
                                const d: any = new Date(b.seanceDate);
                                if (a.seanceDate == b.seanceDate) {
                                    return a.phasePeriodSortFlag - b.phasePeriodSortFlag;
                                }
                                return c - d;
                            });

                            let isClickedButEmpty = false;
                            if (!answersSet.length && isHideButton && isHideButton?.indexOf(target.id) > -1) {
                                // setTimeout(() => {
                                isClickedButEmpty = true;
                                //}, 1000);
                            }

                            const formatAnswers: any[] = [];

                            const answersSetClean = answersSet.filter(function (el: any) {
                                return !el.phasePeriod;
                            });

                            answersSetClean.map((ans: any, t: number) => {
                                let uniqueTitle = '';
                                if (ans?.activePhase?.title) {
                                    const startDate =
                                        ans.activePhase?.startDate &&
                                        ans.activePhase?.startDate > globalFilters.dateFrom &&
                                        ans.activePhase?.startDate < globalFilters.dateTo
                                            ? moment(ans.activePhase?.startDate, 'YYYY-MM-DD HH:mm:ss').format(
                                                  'YYYY-MM-DD',
                                              )
                                            : null;
                                    const endDate =
                                        ans.activePhase?.endDate &&
                                        ans.activePhase?.endDate > globalFilters.dateFrom &&
                                        ans.activePhase?.endDate < globalFilters.dateTo
                                            ? moment(ans.activePhase?.endDate, 'YYYY-MM-DD HH:mm:ss').format(
                                                  'YYYY-MM-DD',
                                              )
                                            : null;
                                    const phaseTitle = ans.activePhase?.title ? ans.activePhase?.title : 'No Phase';
                                    uniqueTitle = phaseTitle + ': ' + startDate;
                                    if (endDate) {
                                        uniqueTitle = uniqueTitle + ' - ' + endDate;
                                    }
                                }

                                formatAnswers.push({
                                    date: moment(ans.seanceDate, 'll').format('YYYY-MM-DD'),
                                    series: uniqueTitle ? uniqueTitle : targetInfo.title,
                                    value: ans?.answer,
                                });
                            });

                            if (!phases.length) {
                                phases.push({
                                    id: 0,
                                    name: targetInfo.title,
                                    start: answersSet.length ? answersSet[0].seanceDate : '',
                                    end: null,
                                });
                            }

                            answersData[target.id] = {
                                target: targetInfo,
                                shortTerm: shortTermInfo,
                                longTerm: longTermInfo,
                                domain: domainInfo,
                                section: sectionInfo,
                                isClickedAnsweredEmpty: isClickedButEmpty,
                                answers: answersSet,
                                phases: phases,
                                formatAnswers: formatAnswers,
                            };
                        });
                        dataShortTermSet[l] = {
                            shortTerm: shortTermInfo,
                            answers: answersData,
                        };
                        answersData = [];
                    });
                    dataLongTermSet[k] = {
                        longTerm: longTermInfo,
                        dataShortTerm: dataShortTermSet,
                    };
                });
                dataDomainSet[j] = {
                    domain: domainInfo,
                    dataLongTerm: dataLongTermSet,
                };
            });
            dataSectionSet[i] = {
                section: sectionInfo,
                dataDomain: dataDomainSet,
            };
        });
        dataSet = dataSectionSet;
    }
    return dataSet;
};
